import React from 'react';

import { formatTimeShortRelativeToToday } from 'lib/helpers/utility';

import Avatar from 'components/shared/Avatar/Avatar';
import Typography from 'components/shared/Typography/Typography';

import ActivityContent from './ActivityContent';

const ActivityLog = ({ activity }) => {
  const { creator, created_at, content, action } = activity;
  const fullName = creator ? `${creator.f_name} ${creator.l_name}` : '';

  return (
    <div className="flex items-start justify-between gap-2 px-4">
      <div className="flex max-w-[calc(100%-80px)] flex-1 items-start gap-2">
        <Avatar fullName={fullName} />
        <ActivityContent creator={creator} content={content} action={action} />
      </div>
      <Typography color="neutral-500" size="small" className="whitespace-nowrap">
        {formatTimeShortRelativeToToday(created_at)}
      </Typography>
    </div>
  );
};

export default ActivityLog;
